module.exports = __webpack_public_path__ + "static/media/signal-alt-3.7b11e0fc.svg";